import { FC } from "react";
import { StaticInfo } from "../../parts/StaticInfo";
import PageSection from "../../parts/StaticPageSection";
import { Helmet } from "react-helmet";

export const CommercialTransactionsPage: FC = () => {
  return <>
    <Helmet>
      <title>特定商取引法に基づく表記 - Drop AI</title>
      <meta name="description" content="Drop AIの特定商取引法に基づく表記を確認できます。" />
      
      <meta property="og:url" content="https://drop4i.com/commercial-transactions" />
      <meta property="og:type" content="website" />
      <meta property="og:title" content="特定商取引法に基づく表記 - Drop AI | 無料で使えるAI画像生成ツール" />
      <meta property="og:description" content="Drop AIの特定商取引法に基づく表記を確認できます。" />
    </Helmet>
    <PageSection title="特定商取引法に基づく表記">
      <StaticInfo title="販売者名" value="株式会社 GO TO MARKET" />
      <StaticInfo title="運営統括責任者" value="木村 暁生" />
      <StaticInfo title="所在地" value="東京都渋谷区道玄坂1-2-3 渋谷フクラス17F" />
      <StaticInfo title="問い合わせ先" value="問い合わせフォームよりお問い合わせください" />
      <StaticInfo title="メールアドレス" value="support_drop.ai@go2mkt.co.jp" />
      <StaticInfo title="電話番号" value="お問合せいただきましたら速やかに開示いたします。" />
      <StaticInfo title="販売URL" value="https://drop4i.com" />
      <StaticInfo title="決済方法" value="クレジットカード" />
      <StaticInfo title="商品代金以外の必要金額" value="インターネットおよび携帯電話での利用には、お客様でご契約の通信事業者などへの通信料が発生します。" />
      <StaticInfo title="商品引渡し方法" value="購入手続き完了後、即時にお引渡しいたします。" />
      <StaticInfo title="返品・交換・キャンセル等" value="法令により払い戻しをするべき場合を除き、理由のいかんに関わらずサービス利用料金の返金を行わないものとします。" />
    </PageSection>
  </>;
}